var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5.58896 7.00445L0.293449 1.70512C0.200444 1.61242 0.126642 1.50222 0.0762827 1.38087C0.0259235 1.25952 -5.62592e-07 1.12941 -5.68336e-07 0.997992C-5.7408e-07 0.866578 0.0259235 0.73646 0.0762827 0.615109C0.126642 0.493758 0.200444 0.383568 0.293449 0.290867C0.482155 0.104488 0.736536 -3.2195e-08 1.00157 -4.378e-08C1.2666 -5.5365e-08 1.52098 0.104488 1.70969 0.290867L7.70853 6.29458C7.89009 6.47678 7.99443 6.72213 7.99978 6.97948C8.00514 7.23684 7.9111 7.48633 7.73727 7.67594L1.7138 13.7221C1.52505 13.903 1.27318 14.0027 1.012 13.9999C0.750824 13.9972 0.501067 13.8923 0.31611 13.7076C0.131152 13.5229 0.0256673 13.2731 0.0222001 13.0115C0.0187329 12.75 0.117558 12.4974 0.297555 12.3079L5.58896 7.00445Z",
    fill: "#242529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderArrowRight);
export default __webpack_public_path__ + "static/media/calender-arrow-right.3fe77d12968e70d4467c1d346b6cb376.svg";
export { ForwardRef as ReactComponent };